import React, { Component } from 'react';
import { Calendar, CalendarProps } from 'primereact/calendar';

class CustomCalendar extends Component<Props> {
  render() {
    const { ...rest } = this.props;
    return (
      <div className={'flex w-full'}>
        <Calendar
          style={{
            border: 'none !important',
          }}
          {...rest}
        />
      </div>
    );
  }
}

interface Props extends CalendarProps {}

export default CustomCalendar;
